import { render, staticRenderFns } from "./BForm.vue?vue&type=template&id=1d42bec2"
import script from "./BForm.vue?vue&type=script&lang=ts"
export * from "./BForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports